module.exports = __webpack_public_path__ + "static/media/hanukkah.bbcf300d.gif";